import { RouteConfig } from 'vue-router';

import { teamExamConductContainerRoute } from '@/routes/teams/team/examConductContainer.route';
import store from '@/store/store';
import { tryParseInt } from '@/utils/number';
import ExamsResult from '@/views/exam/Results.vue';

export const teamExamsResultRoute: RouteConfig = {
  path: ':examId/results',
  name: 'teamExamsResult',
  component: ExamsResult,
  meta: {
    title: '',
    breadcrumb: {
      title: ''
    }
  },
  beforeEnter: (to: any, from: any, next: any) => {
    const teamId = tryParseInt(to.params.teamId);
    const examId = tryParseInt(to.params.examId);
    store.commit('exam/results/setFilters', { examId, teamId, profileId: undefined });
    store.commit('exam/setId', examId);

    teamExamConductContainerRoute.meta.breadcrumb = {
      name: 'teamExamsConduct',
      title: 'breadcrumbs.teams.examConduct'
    };

    Promise.all([store.dispatch('team/player/list', { teamId }), store.dispatch('exam/get')])
      .then(([players, exam]) => {
        teamExamsResultRoute.meta.title = exam.name;
        teamExamsResultRoute.meta.breadcrumb.title = exam.name;
        if (!to.query.order) {
          next({ name: to.name, params: to.params, query: { order: 'date', desc: true } });
        } else {
          next();
        }
      })
      .catch(() => store.dispatch('notifyError', { title: 'messages.team.player.listError' }));
  }
};
